export default __webpack_public_path__ + "static/media/128x128.1d67fbf0.jpg";